// Central constants for the tavern landing page
export const TAVERN = {
  name: "Πρώτο Κατσίκι",
  tagline: "Η αυθεντική γεύση της Καβάλας",
  phone: "+30 2510 223983",
  phoneDisplay: "2510 223983",
  phoneTel: "+302510223983",
  efoodUrl: "https://www.e-food.gr/delivery/kavala/proto-katsiki",
  address: "Αμερικανικού Ερυθρού Σταυρού 192, 65201 Καβάλα",
  mapQuery:
    "Πρώτο+Κατσίκι+Αμερικανικού+Ερυθρού+Σταυρού+192+Καβάλα",
  rating: "4.5",
  reviews: "1.500+",
  logo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_authentic-tavern/artifacts/v3y4p81m_%CE%91%CE%BD%CF%89%CC%81%CE%BD%CF%85%CE%BC%CE%BF%20%CF%83%CF%87%CE%B5%CC%81%CE%B4%CE%B9%CE%BF.png",
  facebookUrl:
    "https://www.facebook.com/people/%CE%A0%CF%81%CF%8E%CF%84%CE%BF-%CE%BA%CE%B1%CF%84%CF%83%CE%AF%CE%BA%CE%B9/100054225500533/",
  instagramUrl: "https://www.instagram.com/protokatsiki/?hl=el",
};

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/9ke9i7fd__MPH6801.JPG";

export const MENU_ITEMS = [
  {
    id: "katsiki",
    title: "Μάγουλα",
    description:
      "Μοσχαρίσια μάγουλα σιγομαγειρεμένα σε σάλτσα κρασιού με πατάτες φούρνου και τριμμένο τυρί. Λιώνουν στο στόμα.",
    image:
      "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/mrt3phjc_%CE%9C%CE%B1%CC%81%CE%B3%CE%BF%CF%85%CE%BB%CE%B1.jpg",
    badge: "ΣΠΕΣΙΑΛΙΤΕ",
  },
  {
    id: "mezedes",
    title: "Παραδοσιακοί Μεζέδες",
    description:
      "Τζατζίκι, μελιτζανοσαλάτα, κεφτεδάκια, σαγανάκι — μοιραστείτε τη γεύση της παράδοσης.",
    image:
      "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/dqhgs23o_%CE%A6%CE%B5%CC%81%CF%84%CE%B1%20%CE%BC%CE%B5%CC%81%CE%BB%CE%B9.jpg",
    badge: "ΑΓΑΠΗΜΕΝΟ",
  },
  {
    id: "sxaras",
    title: "Της Ώρας στα Κάρβουνα",
    description:
      "Παϊδάκια, κοντοσούβλι, μπριζόλες χοιρινές — ψημένα σε πραγματικά κάρβουνα.",
    image:
      "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/kmj5p57i_%CE%9C%CE%B5%CE%BE%CE%B9%CE%BA%CE%B1%CC%81%CE%BD%CE%B1.jpg",
    badge: "ΣΧΑΡΑ",
  },
];

export const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/9ke9i7fd__MPH6801.JPG",
    alt: "Ρουστίκ τραπέζι της ταβέρνας με πινακίδα Reserved",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/7c8gasn8__MPH6837.JPG",
    alt: "Τσίπουρο Θάλασσα χωρίς γλυκάνισο στο τραπέζι",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/x8ud9rn5__MPH8736.jpg",
    alt: "Χταπόδι ψητό στη σχάρα με κόκκινο κρεμμύδι",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/s22iwxt9__MPH7008.JPG",
    alt: "Κοντοσούβλι στα κάρβουνα",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/0aisy9kr__MPH8737.jpg",
    alt: "Πιπεριά Φλωρίνης ψητή με λάδι και ρίγανη",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/ifcngnat__MPH8740.jpg",
    alt: "Λαχανοσαλάτα με πιπεριές και ελιές",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_authentic-tavern/artifacts/96khgbdz__MPH8727.jpg",
    alt: "Παραδοσιακοί μεζέδες στο τραπέζι",
  },
];

export const HOURS = [
  { day: "Δευτέρα", value: "11:00 – 23:30" },
  { day: "Τρίτη", value: "11:00 – 23:30" },
  { day: "Τετάρτη", value: "11:00 – 23:30" },
  { day: "Πέμπτη", value: "11:00 – 23:30" },
  { day: "Παρασκευή", value: "11:00 – 23:30" },
  { day: "Σάββατο", value: "11:00 – 01:00" },
  { day: "Κυριακή", value: "11:00 – 23:30" },
];
